/**
 * Single source of truth for the backend base URL.
 * Production goes through the Firebase Hosting /api rewrite to the `main`
 * Cloud Function; development hits the local emulator.
 */
export const API_BASE_URL =
  process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001';
